import loadable from "@loadable/component";

const LandingAir = loadable(() => import("./LandingAir.page"));

export default { component: LandingAir };
